import { ProductCode } from "../../../models/ProductCode";
import { PagedResult, Result } from "../../../models/Result";
import { SearchRequestBaseModel } from "../../../models/SearchRequestModel";
import { httpService } from "../../HttpService";
import { BillTariffModel, CreateBillTariffRequest, UpdateBillTariffRequest } from "../../../models/BillTariff";

class TariffApiService{
    path: string = "Tariff";

    getProductCodes = async (request: SearchRequestBaseModel): Promise<PagedResult<ProductCode[]>> => await httpService.getPage<ProductCode[]>(`/${this.path}/product-codes`, request);

    // Bill Tariff CRUD operations
    getAllBillTariffs = async (): Promise<Result<BillTariffModel[]>> => await httpService.get<BillTariffModel[]>(`/${this.path}/bill-tariffs`);

    getAllBillTariffsPaged = async (request: SearchRequestBaseModel): Promise<PagedResult<BillTariffModel[]>> => await httpService.getPage<BillTariffModel[]>(`/${this.path}/bill-tariffs`, request);

    getBillTariffById = async (id: number): Promise<Result<BillTariffModel>> => await httpService.get<BillTariffModel>(`/${this.path}/bill-tariffs/${id}`);

    createBillTariff = async (request: CreateBillTariffRequest): Promise<Result<BillTariffModel>> => await httpService.post<BillTariffModel>(`/${this.path}/bill-tariffs/create`, request);

    updateBillTariff = async (request: UpdateBillTariffRequest): Promise<Result<BillTariffModel>> => await httpService.put<BillTariffModel>(`/${this.path}/bill-tariffs/update`, request);

    toggleBillTariffStatus = async (id: number): Promise<Result<void>> => await httpService.put<void>(`/${this.path}/bill-tariffs/${id}/toggle-status`, {});

    deleteBillTariff = async (id: number): Promise<Result<void>> => await httpService.delete<void>(`/${this.path}/bill-tariffs/${id}`);
}

const tariffApiService = new TariffApiService();

export default tariffApiService;